import { useEffect, useState } from "react";
import api, { imageUrl } from "../lib/api";

let cachedSettings = null;
let pendingRequest = null;

export function useSiteSettings() {
  const [settings, setSettings] = useState(cachedSettings);
  useEffect(() => {
    if (cachedSettings) return;
    if (!pendingRequest) {
      pendingRequest = api
        .get("/settings")
        .then((r) => {
          cachedSettings = r.data;
          return r.data;
        })
        .catch(() => null);
    }
    pendingRequest.then((s) => s && setSettings(s));
  }, []);
  return settings;
}

export function SiteLogo({ size = "md", showText = true }) {
  const settings = useSiteSettings();
  const [imgError, setImgError] = useState(false);
  const imgCls = size === "lg" ? "h-11" : "h-9";
  const src = settings?.logo && !imgError ? imageUrl(settings.logo) : "/logo.png";
  return (
    <span className="inline-flex items-center gap-3" data-testid="site-logo">
      <img
        src={src}
        onError={() => setImgError(true)}
        alt="Hoom Agency"
        className={`${imgCls} w-auto max-w-[160px] object-contain rounded-lg`}
      />
      {showText && <span className="font-display font-700 text-sm tracking-wide text-white">Hoom Agency</span>}
    </span>
  );
}
